const notifications = ({ apiClient }) => ({
  list(params = {}, headers = {}) {
    return apiClient.get('notifications', {}, params, headers)
  },
  markAsRead(notificationId, payload = {}, headers = {}) {
    return apiClient.post(`notifications/${notificationId}/read`, payload, {}, headers)
  },
})

export default notifications
